<div class="app-container settings" [class.chat-pinned]="displayMode === 'pinned'">
    @if (isDesktopLayout$ | async) {
        <app-desktop-menu></app-desktop-menu>
    } @else {
        @if (hasNotDismissedBanner$ | async; as notDismissedOnboardingGuide) {
            <app-setup-guide-button
                [hasNotDismissedBanner]="notDismissedOnboardingGuide"
                [asapFormId$]="asapFormId$">
            </app-setup-guide-button>
        }
    }

    <div
        class="settings app-main"
        [class.no-mobile-nav-padding]="(showMobileNavChrome$ | async) === false">
        <router-outlet></router-outlet>
    </div>

    @if ((isDesktopLayout$ | async) !== true) {
        @if (showMobileNavChrome$ | async) {
            @if (showContextualBar$ | async) {
                <app-mobile-contextual-bar></app-mobile-contextual-bar>
            } @else {
                <app-mobile-bottom-nav></app-mobile-bottom-nav>
            }
        }
    }

    <app-mobile-options-panel></app-mobile-options-panel>

    @if (displayMode !== 'pinned') {
        <button
            *featureFlag="'riseAgent'"
            class="rise-fab"
            type="button"
            title="Open RISE Agent"
            (click)="openRiseAgent()">
            <span class="rise-fab-inner">
                <app-rise-agent-icon variant="onBlue" class="icon" [size]="24"></app-rise-agent-icon>
            </span>
            <span class="rise-fab-label">Ask RISE</span>
        </button>
    }

    <app-rise-agent-sidebar
        *featureFlag="'riseAgent'"
        [visible]="riseAgentVisible"
        (visibleChange)="onRiseAgentVisibleChange($event)">
    </app-rise-agent-sidebar>
</div>
